import { createSlice } from '@reduxjs/toolkit'

export const setKioskOpenReducer = (state, payload) => {
  const kioskOpen = payload.payload

  const newState = {
    ...state,
    kioskOpen
  }
  return newState
}

export const setBuilderOpenReducer = (state, payload) => {
  const builderOpen = payload.payload

  const newState = {
    ...state,
    builderOpen
  }
  return newState
}

export const setStandardBuilderOpenReducer = (state, payload) => {
  const standardBuilderOpen = payload.payload

  const newState = {
    ...state,
    standardBuilderOpen
  }
  return newState
}

export const setSecurityOpenReducer = (state, payload) => {
  const securityOpen = payload.payload

  const newState = {
    ...state,
    securityOpen
  }
  return newState
}

export const setClasscodeRosterOpenReducer = (state, { payload }) => {
  const { classcodeRosterOpen, isNewClass } = payload

  const newState = {
    ...state,
    classcodeRosterOpen,
    isNewClass
  }
  return newState
}

export const setStudentRosterOpenReducer = (state, payload) => {
  const studentRosterOpen = payload.payload

  const newState = {
    ...state,
    studentRosterOpen

  }
  return newState
}

export const setCsvOpenReducer = (state, payload) => {
  const csvOpen = payload.payload

  const newState = {
    ...state,
    csvOpen
  }
  return newState
}

export const setStudentDetailOpenRecuer = (state, payload) => {
  const studentDetailOpen = payload.payload

  const newState = {
    ...state,
    studentDetailOpen
  }
  return newState
}

export const setCleverInfoOpenReducer = (state, payload) => {
  const cleverInfoOpen = payload.payload

  const newState = {
    ...state,
    cleverInfoOpen
  }

  return newState
}

export const setGoogleSyncOpenReducer = (state, payload) => {
  const googleSyncOpen = payload.payload

  const newState = {
    ...state,
    googleSyncOpen
  }

  return newState
}

export const setAllClosedReducer = (state) => {
  const newState = {
    ...state,
    kioskOpen: false,
    builderOpen: false,
    standardBuilderOpen: false,
    securityOpen: false,
    classcodeRosterOpen: false,
    csvOpen: false,
    studentRosterOpen: false,
    studentDetailOpen: false,
    cleverInfoOpen: false,
    googleSyncOpen: false
  }
  return newState
}

const modalsSlice = createSlice({
  name: 'classroomModal',
  initialState: {
    kioskOpen: false,
    builderOpen: false,
    standardBuilderOpen: false,
    securityOpen: false,
    classcodeRosterOpen: false,
    csvOpen: false,
    studentRosterOpen: false,
    studentDetailOpen: false,
    isNewClass: false,
    cleverInfoOpen: false,
    googleSyncOpen: false
  },
  reducers: {
    setKioskOpen: setKioskOpenReducer,
    setBuilderOpen: setBuilderOpenReducer,
    setStandardBuilderOpen: setStandardBuilderOpenReducer,
    setSecurityOpen: setSecurityOpenReducer,
    setClasscodeRosterOpen: setClasscodeRosterOpenReducer,
    setStudentRosterOpen: setStudentRosterOpenReducer,
    setCsvOpen: setCsvOpenReducer,
    setStudentDetailOpen: setStudentDetailOpenRecuer,
    setAllClosed: setAllClosedReducer,
    setCleverInfoOpen: setCleverInfoOpenReducer,
    setGoogleSyncOpen: setGoogleSyncOpenReducer
  }
})

const { actions, reducer } = modalsSlice

export const {
  setKioskOpen,
  setBuilderOpen,
  setStandardBuilderOpen,
  setSecurityOpen,
  setClasscodeRosterOpen,
  setStudentRosterOpen,
  setCsvOpen,
  setStudentDetailOpen,
  setCleverInfoOpen,
  setGoogleSyncOpen,
  setAllClosed
} = actions

export default reducer
